import request from '@/utils/request'
const post = (url, data, type) => {
  return request({
    url: url,
    headers: {
      'Content-Type': type
    },
    method: 'post',
    data
  })
}
const get = (url, data, type) => {
  return request({
    url: url,
    headers: {
      'Content-Type': type
    },
    method: 'get',
    params: data
  })
}
const req = (url, data, type, method) => {
  return request({
    url,
    headers: {
      'Content-Type': type
    },
    method: method ? method : 'post',
    params: data
  })
}
export {
  post,
  get,
  req
}